import { POST_PURCHASE_FINAL_STEPS } from "@/domains/surveys/models/constants";
import { env } from "@/env";

export type MockFlowOutcome = {
  label: string;
  description: string;
  stepId: string;
};

const DEFAULT_OUTCOMES: MockFlowOutcome[] = [
  {
    label: "Complete the flow",
    description: "Sends the same finalize event the real embed sends on its last step.",
    stepId: "flow_complete",
  },
];

const OUTCOMES_BY_FLOW_LABEL: Record<string, MockFlowOutcome[]> = {
  [env.VITE_FORMSORT_PROFILING_FLOW_LABEL]: [
    {
      label: "Finish profiling",
      description:
        "Continues to the password step, which signs you in as a new patient whose plan is under review.",
      stepId: "contact_information",
    },
    {
      label: "End as not eligible",
      description: "Ends on the under-21 step. The app stays on this page, as it does for real.",
      stepId: "under_21",
    },
  ],
  [env.VITE_FORMSORT_SURVEY_FLOW_LABEL]: [
    {
      label: "Submit check-in",
      description: "Completes the check-in and follows the app to the screen it picks next.",
      stepId: "check_in_complete",
    },
  ],
  [env.VITE_FORMSORT_POST_PURCHASE_SURVEY_FLOW_LABEL]: [
    {
      label: "Show recommendations",
      description: "Ends on the step that leads to personalized next steps and products.",
      stepId: POST_PURCHASE_FINAL_STEPS.SHOW_RECOMMENDATIONS,
    },
    {
      label: "Show subscription offer",
      description: "Ends on the step that invites the buyer to subscribe and save.",
      stepId: POST_PURCHASE_FINAL_STEPS.SHOW_SUBSCRIPTION,
    },
    {
      label: "Finish without a next step",
      description: "Leaves the survey, as the real flow does when no follow-up applies.",
      stepId: "thank_you",
    },
  ],
};

export const getMockFlowOutcomes = (flowLabel: string) => {
  return OUTCOMES_BY_FLOW_LABEL[flowLabel] ?? DEFAULT_OUTCOMES;
};
